import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import _ from "underscore";
import { IsNullOrEmpty, validEmail, validPhone } from "../../helpers/utility";
import { updateCartRequest } from "../../store/shopping/shopping.actions";
import {
    getCartList,
    getCartProductList,
} from "../../store/shopping/shopping.selector";
import { getDeliveryAddressRequest } from "../../store/user/deliveryaddress/deliveryaddress.actions";
import DeliveryAddressAPI from "../../store/user/deliveryaddress/deliveryaddress.api";
import { getDeliveryAddresses } from "../../store/user/deliveryaddress/deliveryaddress.selector";
import { getImage, getSearchedUsers } from "../../store/user/user.selector";
var api_key = process.env.REACT_APP_GOOGLE_API_KEY;
var currency = "";
var myProps = {};

const Checkout = (props) => {
    const location = useLocation();
    const history = useNavigate();
    const [shipment, setShipment] = useState({});
    const [selectedAddress, setSelectedAddress] = useState("");
    const [mode, setMode] = useState("Checkout");
    const [validationError, setValidationError] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [selectedItems, setSelectedItems] = useState([]);
    const [calculating, setCalculating] = useState(false);
    const [name, setName] = useState("");
    const [showPic, setPic] = useState(false);
    const [lName, setLName] = useState("");
    const [phone, setPhone] = useState("");
    const [address, setAddress] = useState("");
    const [address1, setAddress1] = useState("");
    const [city, setCity] = useState("");
    const [postCode, setPostCode] = useState("");
    const [cities, setCities] = useState([]);
    const [states, setStates] = useState([]);
    const [email, setEmail] = useState("");
    const [state, setCurState] = useState("");
    const [nickName, setNickName] = useState("");
    const [isNew, setNew] = useState(false);
    const [status, setStatus] = useState("Active");
    const [selected, setSelected] = useState("MY");
    const [countryCode, setCountry] = useState("+60");
    const [form, setForm] = useState(false);
    const [isAlert, showAlert] = useState({
        show: false,
        message: "",
        type: "default",
        title: "",
        btnText: "",
        onConfirm: () => {},
    });
    const dispatch = useDispatch();

    const getCountryByCode = (code) => {
        if (code == "+65") return "SG";
        if (code == "+60") return "MY";
        if (code == "+1") return "US";
    };

    useEffect(() => {
        if (mode === "Address" && !IsNullOrEmpty(selectedAddress._id)) {
            setCalculating(true);
            let ids = selectedItems.map((x) => x.product && x.product.user.id);
            let curItems = selectedItems;
            DeliveryAddressAPI.GetSellerAddress({
                ids: ids,
            })
                .then((res) => {
                    let shipment = ids.map((y) => {
                        let addr = _.find(res.data, (s) => s.user === y);
                        if (!addr) {
                            Swal.fire({
                                icon: "warning",
                                title: "Seller zip code not available",
                                text: "Seller didn't configured the zip code.Please try again later",
                                customClass: {
                                    cancelButton: "order-1 right-gap",
                                    confirmButton: "order-2",
                                    denyButton: "order-3",
                                },
                            });
                            setValidationError(true);
                        }
                        return {
                            pick_code: addr.postCode,
                            pick_country: getCountryByCode(addr.country),
                            send_code: addr.postCode,
                            send_country: getCountryByCode(addr.country),
                            weight: 2,
                        };
                    });
                    DeliveryAddressAPI.GetShippingAmount(shipment)
                        .then((x) => {
                            let ship = {};
                            if (x.data) {
                                x.data.result.forEach((y, index) => {
                                    ship[curItems[index].product._id] =
                                        y.rates[0].shipment_price;
                                    curItems[index].product.shippingFee =
                                        y.rates[0].shipment_price;
                                });
                                setSelectedItems(curItems);
                                setCalculating(false);
                                setShipment(ship);
                            }
                        })
                        .catch(() => {
                            setCalculating(false);
                        });
                })
                .catch(() => {
                    setCalculating(false);
                });
        }
    }, [mode, selectedAddress]);

    useEffect(() => {
        if (location && location.state && location.state.checkout) {
            if (carts.cartItems && carts.cartItems.length > 0) {
                let cartItems = carts.cartItems.filter((x) => {
                    return x.product._id === location.state.product;
                });
                setMode("Address");
                setSelectedItems(cartItems);
            }
        }
    }, [location]);

    const handleSelect = (code) => {
        setSelected(code);
        if (code === "SG") setCountry("+65");
        if (code === "MY") setCountry("+60");
        if (code === "US") setCountry("+1");
    };

    const handleChecked = (item, isChecked) => {
        if (isChecked) {
            setSelectedAddress(item);
        } else {
            setSelectedAddress({});
        }
    };

    const { carts, deliveryAddresses, allUsers, isCartLoading } = useSelector(
        (state) => {
            return {
                carts: getCartList(state),
                cartProducts: getCartProductList(state),
                deliveryAddresses: getDeliveryAddresses(state),
                allUsers: getSearchedUsers(state),
                isCartLoading: state.ShoppingReducer.isCartLoading,
            };
        }
    );

    useEffect(() => {
        setName("");
        setNickName("");
        setPhone("");
        setAddress("");
        setAddress1("");
        setPostCode("");
        setCurState("");
        setEmail("");
        setCity("");
        setForm(false);
    }, [isNew]);

    const handleClick = (id, img) => {
        myProps = { width: 256, height: 256, zoomWidth: 512, img: img };
        setPic(true);
    };

    useEffect(() => {
        let curItems = selectedItems;

        curItems = selectedItems.map((x) => {
            let productCodes = carts.cartItems.filter(
                (y) => y.product.code === x.product.code
            );
            if (productCodes.length > 0) {
                x.quantity = productCodes[0].quantity;
            }
            return x;
        });
        if (mode === "Address") {
            if (location && location.state && location.state.checkout) {
                if (carts.cartItems.length > 0) {
                    let cartItems = carts.cartItems.filter((x) => {
                        return x.product._id === location.state.product;
                    });
                    setMode("Address");
                    setSelectedItems(cartItems);
                }
            }
        } else {
            setSelectedItems(curItems);
        }
    }, [carts]);

    const validate = () => {
        return (
            !IsNullOrEmpty(name) &&
            !IsNullOrEmpty(address) &&
            !IsNullOrEmpty(address1) &&
            !IsNullOrEmpty(city) &&
            !IsNullOrEmpty(state) &&
            !IsNullOrEmpty(postCode) &&
            !IsNullOrEmpty(phone) &&
            !IsNullOrEmpty(email) &&
            validPhone(phone) &&
            validEmail(email)
        );
    };

    const handleSave = () => {
        if (validate()) {
            let data = {
                name: name,
                phone: countryCode + phone,
                address: address,
                subAddress: address1,
                city: city,
                isDefault: true,
                isSeller: false,
                postCode: postCode,
                status: status,
                state: state,
                country: countryCode,
                nickName: IsNullOrEmpty(nickName) ? name : nickName,
                email: email,
            };

            DeliveryAddressAPI.CreateDeliveryAddress(data).then((x) => {
                dispatch(getDeliveryAddressRequest());
                setSelectedAddress(x.data);
                setNew(false);
            });
        } else {
            setForm(true);
        }
    };

    const updateCartProductItem = (id, qty, isAdd) => {
        if (isAdd) {
            qty = qty + 1;
        } else {
            qty = qty - 1;
        }
        dispatch(
            updateCartRequest({
                product: id,
                quantity: qty,
            })
        );
    };

    const handleDelete = (id) => {
        dispatch(
            updateCartRequest({
                product: id,
                quantity: 0,
            })
        );
    };

    let cartList = [];
    if (carts && carts.cartItems) {
        cartList = carts.cartItems;
    }

    if (!IsNullOrEmpty(searchText)) {
        cartList = cartList.filter((item) => {
            return (
                item.product.user.userName
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) > -1 ||
                item.product.code
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) > -1 ||
                item.product.name
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) > -1 ||
                item.product.descriptions
                    .toLowerCase()
                    .indexOf(searchText.toLowerCase()) > -1
            );
        });
    }

    let prices = selectedItems.map((x) => {
        return x.product.price * x.quantity;
    });

    let shippingPrices = selectedItems.map((x) => {
        return x.product.shippingFee * x.quantity;
    });

    let qtys = selectedItems.map((x) => {
        return x.quantity;
    });

    let totalProductPrice = _.reduce(
        prices,
        function (memo, num) {
            return memo + num;
        },
        0
    );
    let totalShippingFee = _.reduce(
        shippingPrices,
        function (memo, num) {
            return memo + num;
        },
        0
    );
    let orderTotal = _.reduce(
        qtys,
        function (memo, num) {
            return memo + num;
        },
        0
    );

    return (
        <div>
            <div className="relative mb-3.5">
                <input
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    type="search"
                    className="py-2.5 pl-12 w-full text-black-color placeholder:text-black-60 border border-black-10 rounded-[40px] text-sm sm:text-sm outline-none"
                    placeholder="Search"
                />

                <span className="text-xl absolute top-2/4 -translate-y-2/4 left-5 text-black-60">
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.29583 11.5892 8.49572 10.8907 9.47653L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.47653 10.8907C8.49572 11.5892 7.29583 12 6 12C2.68629 12 0 9.31371 0 6Z"
                            fill="black"
                            fillOpacity="0.5"
                        />
                    </svg>
                </span>
            </div>

            <div className=" ">
                <div className="w-full text-sm text-left">
                    <div className=" capitalize  text-sm font-medium text-black-60">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <div className="pr-2">
                                    <div className="flex items-center">
                                        <input
                                            id="checkbox-all-search"
                                            type="checkbox"
                                            className="w-[18px] h-[18px] text-blue-600 bg-white border border-black-10 rounded "
                                            checked={
                                                selectedItems.length >=
                                                cartList.length
                                            }
                                            onChange={(e) => {
                                                if (!e.target.checked) {
                                                    setSelectedItems([]);
                                                } else {
                                                    setSelectedItems(cartList);
                                                }
                                            }}
                                        />
                                        <label
                                            htmlFor="checkbox-all-search"
                                            className="sr-only"
                                        ></label>
                                    </div>
                                </div>
                                <div className="py-3">item</div>
                            </div>
                            <div className="py-3 text-right">Accesories</div>
                        </div>
                    </div>
                    <div className="space-y-14 lg:space-x-0">
                        {cartList &&
                            cartList.map((x) => {
                                let isActive =
                                    selectedItems.filter(
                                        (y) => y.product._id === x.product._id
                                    ).length > 0;
                                if (!x.product.user) {
                                    return <p></p>;
                                }
                                return (
                                    <div
                                        key={x.id}
                                        className="grid grid-cols-2 gap-y-2 lg:grid-cols-5"
                                    >
                                        <div className="  w-4 hidden">
                                            <div className="flex items-center">
                                                <input
                                                    id="checkbox-table-search-1"
                                                    type="checkbox"
                                                    className="w-[18px] h-[18px] text-blue-600 bg-white border border-black-10 rounded"
                                                    checked={isActive}
                                                    onChange={(e) => {
                                                        if (!e.target.checked) {
                                                            let newItems =
                                                                selectedItems.filter(
                                                                    (y) =>
                                                                        y
                                                                            .product
                                                                            ._id !==
                                                                        x
                                                                            .product
                                                                            ._id
                                                                );
                                                            setSelectedItems(
                                                                newItems
                                                            );
                                                        } else {
                                                            setSelectedItems([
                                                                ...selectedItems,
                                                                x,
                                                            ]);
                                                        }
                                                    }}
                                                />
                                                <label
                                                    htmlFor="checkbox-table-search-1"
                                                    className="sr-only"
                                                ></label>
                                            </div>
                                        </div>
                                        <div className="  whitespace-nowrap w-fit col-span-2 sm:col-span-1 lg:col-span-2 flex items-center">
                                            <div className="flex items-center mr-2">
                                                <input
                                                    id="checkbox-table-search-1"
                                                    type="checkbox"
                                                    className="w-[18px] h-[18px] text-blue-600 bg-white border border-black-10 rounded"
                                                    checked={isActive}
                                                    onChange={(e) => {
                                                        if (!e.target.checked) {
                                                            let newItems =
                                                                selectedItems.filter(
                                                                    (y) =>
                                                                        y
                                                                            .product
                                                                            ._id !==
                                                                        x
                                                                            .product
                                                                            ._id
                                                                );
                                                            setSelectedItems(
                                                                newItems
                                                            );
                                                        } else {
                                                            setSelectedItems([
                                                                ...selectedItems,
                                                                x,
                                                            ]);
                                                        }
                                                    }}
                                                />
                                                <label
                                                    htmlFor="checkbox-table-search-1"
                                                    className="sr-only"
                                                ></label>
                                            </div>
                                            <div className=" flex items-center justify-start">
                                                <img
                                                    src={x.product.images}
                                                    alt=""
                                                    className="w-16 h-16 rounded-lg mr-[18px]"
                                                />
                                                <div className="">
                                                    <h4 className="text-sm font-medium text-ebony-color mb-0.5">
                                                        {x.product.name}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="ml-5 lg:ml-0 col-span-2 sm:col-span-1 md:col-auto">
                                            <div className="flex items-start justify-between lg:justify-start">
                                                <img
                                                    src={getImage(
                                                        x.product.user
                                                            .attachment,
                                                        "product"
                                                    )}
                                                    className="w-[34px] h-[34px] rounded-full mr-2"
                                                    alt=""
                                                />
                                                <div className="mr-3">
                                                    <h5 className="text-sm font-medium text-black-60 capitalize">
                                                        {
                                                            x.product.user
                                                                .userName
                                                        }
                                                    </h5>
                                                    <div className="flex items-center space-x-px">
                                                        <span>
                                                            <svg
                                                                width="12"
                                                                height="11"
                                                                viewBox="0 0 12 11"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                    fill="#FFB800"
                                                                />
                                                            </svg>
                                                        </span>
                                                        <span>
                                                            <svg
                                                                width="12"
                                                                height="11"
                                                                viewBox="0 0 12 11"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                    fill="#FFB800"
                                                                />
                                                            </svg>
                                                        </span>
                                                        <span>
                                                            <svg
                                                                width="12"
                                                                height="11"
                                                                viewBox="0 0 12 11"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                    fill="#FFB800"
                                                                />
                                                            </svg>
                                                        </span>
                                                        <span>
                                                            <svg
                                                                width="12"
                                                                height="11"
                                                                viewBox="0 0 12 11"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                    fill="#FFB800"
                                                                />
                                                            </svg>
                                                        </span>
                                                        <span>
                                                            <svg
                                                                width="12"
                                                                height="11"
                                                                viewBox="0 0 12 11"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                            >
                                                                <path
                                                                    d="M5.95117 0L7.29826 4.1459H11.6575L8.1308 6.7082L9.47788 10.8541L5.95117 8.2918L2.42446 10.8541L3.77154 6.7082L0.244833 4.1459H4.60409L5.95117 0Z"
                                                                    fill="#FFB800"
                                                                />
                                                            </svg>
                                                        </span>
                                                    </div>
                                                </div>
                                                <p className="ml-auto lg:m-0 text-sm font-medium text-orange-color whitespace-nowrap capitalize">
                                                    {
                                                        x.product.warehouse
                                                            .purcharse
                                                    }{" "}
                                                    sold
                                                </p>
                                            </div>
                                        </div>
                                        <div className="ml-5 lg:ml-0 ">
                                            <div className="flex items-center">
                                                <div className="grid grid-cols-3 w-[74px] h-[26px] rounded-[4px] mr-2.5">
                                                    <button
                                                        onClick={() =>
                                                            updateCartProductItem(
                                                                x.product._id,
                                                                x.quantity,
                                                                false
                                                            )
                                                        }
                                                        className="flex justify-center items-center border-[0.6px] border-black-20 border-r-0 rounded-tl-[4px]  rounded-bl-[4px]"
                                                    >
                                                        <svg
                                                            width="8"
                                                            height="2"
                                                            viewBox="0 0 8 2"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M7.33463 0.666504H0.667969"
                                                                stroke="black"
                                                                strokeOpacity="0.3"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </button>

                                                    <span className="flex justify-center items-center p-1.5 border-[0.6px] border-black-20 text-extraSmall text-ebony-color font-medium">
                                                        {x.quantity}
                                                    </span>

                                                    <button
                                                        onClick={() =>
                                                            updateCartProductItem(
                                                                x.product._id,
                                                                x.quantity,
                                                                true
                                                            )
                                                        }
                                                        className="flex justify-center items-center border-[0.6px] border-black-20 border-l-0  rounded-tr-[4px] rounded-br-[4px]"
                                                    >
                                                        <svg
                                                            width="14"
                                                            height="14"
                                                            viewBox="0 0 14 14"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                d="M6.66732 3.3335V6.66683M6.66732 6.66683V10.0002M6.66732 6.66683H10.0006M6.66732 6.66683L3.33398 6.66683"
                                                                stroke="black"
                                                                strokeOpacity="0.3"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </button>
                                                </div>

                                                <p
                                                    onClick={() => {
                                                        Swal.fire({
                                                            icon: "warning",
                                                            title: "Remove from cart?",
                                                            text: "You need to add to cart again to checkout",
                                                            confirmButtonText:
                                                                "Remove",
                                                            showConfirmButton: true,
                                                            showCancelButton: true,
                                                            customClass: {
                                                                cancelButton:
                                                                    "order-1 right-gap",
                                                                confirmButton:
                                                                    "order-2",
                                                                denyButton:
                                                                    "order-3",
                                                            },
                                                        }).then((res) => {
                                                            if (
                                                                res.isConfirmed
                                                            ) {
                                                                handleDelete(
                                                                    x.product
                                                                        ._id
                                                                );
                                                            }
                                                        });
                                                    }}
                                                    className="text-sm font-medium text-orange-color capitalize"
                                                >
                                                    Remove
                                                </p>
                                            </div>
                                        </div>
                                        <div className=" text-sm font-medium text-orange-color text-right whitespace-nowrap">
                                            {x.product.currency}{" "}
                                            {x.product.price}
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </div>

            <div className=" mt-14 ">
                <div className="flex justify-end mb-5">
                    <p className="text-sm font-medium text-black-50 capitalize">
                        total{" "}
                        <span className="text-orange-color ml-1">
                            {currency}{" "}
                            {(totalProductPrice + totalShippingFee).toFixed(2)}
                        </span>
                    </p>
                </div>
                <button
                    disabled={selectedItems.length === 0}
                    onClick={() => {
                        if (selectedItems.length > 0) {
                            setMode("Address");
                        }
                    }}
                    className="text-sm font-bold text-white py-2.5 px-10 bg-orange-color capitalize rounded-lg"
                >
                    Checkout
                </button>
            </div>
        </div>
    );
};

export default Checkout;
